// client/src/utils/emails.js
import api from './api';

function normalizeRecipients({ toEmail, toEmails }) {
    if (Array.isArray(toEmails)) {
        return toEmails.map((email) => String(email || '').trim()).filter(Boolean);
    }
    return toEmail ? [String(toEmail).trim()].filter(Boolean) : [];
}

export async function queueFinalizedJobEmail({ jobId, toEmail, toEmails, subject, bodyText }) {
    const recipients = normalizeRecipients({ toEmail, toEmails });
    const payload = {
        jobId,
        toEmails: recipients,
    };
    if (subject) payload.subject = subject;
    if (bodyText) payload.bodyText = bodyText;

    const { data } = await api.post('/emails/queue-job-finalized-pdf', payload);
    return data;
}

export async function cancelQueuedEmail(id) {
    const { data } = await api.post(`/emails/${id}/cancel`);
    return data;
}

export async function fetchEmailStatus(id) {
    const { data } = await api.get(`/emails/${id}/status`);
    return data;
}
